import { Link } from 'react-router-dom'

import '../css/Header.css'

const Header = () => {
  return (
    <div className="Menu">
      <div className="Names">Qinren Zhou</div>

      <Link className="MenuItems" to="/about">
        About
      </Link>

      <Link className="MenuItems" to="/projects">
        Projects
      </Link>

      <Link className="MenuItems" to="/resume">
        CV
      </Link>
    </div>
  )
}

export default Header
